import { render, staticRenderFns } from "./SegmentedGroup.vue?vue&type=template&id=0aabcb81"
import script from "./SegmentedGroup.vue?vue&type=script&lang=js"
export * from "./SegmentedGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports